<template>
  <div class="header" :class="{'header--visible': isHidden}">
    <button class="header__icon header__icon--menu" @click="showNav"><i class="fas fa-bars"></i></button>
    <input class="header__input" type="text" v-model="query" placeholder="Czego szukasz?" @keyup.enter="search">
    <button class="header__icon header__icon--right" @click="clear" v-if="query !== ''"><i class="fas fa-times"></i></button>
    <!-- <button
      class="header__icon header__icon--right"
      :class="{'header__icon--notifications': hasNotifications}"
    ><i class="far fa-bell"></i></button> -->
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'app-header',
  data: () => {
    return {
      query: ''
    }
  },
  computed: {
    isHidden() {
      return !this.$route.meta.hiddenNav
    },
    hasNotifications() {
      return this.$store.getters.hasNotifications
    },
    globalQuery() {
      return this.$store.state.docs.query
    }
  },
  methods: {
    showNav() {
      this.$store.commit('showNav')
    },
    search() {
      if(this.query.toLowerCase() !== this.globalQuery.toLowerCase()) {
        this.$router.push(`/docs/${this.query.replace(' ', '-')}`)
      }
    },
    clear() {
      this.query = ''
      this.search()
    }
  },
  watch: {
    globalQuery() {
      this.query = _.capitalize(this.globalQuery)
    },
    '$route' (to){
      if(to.name !== 'docs') {
        this.query = ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .header {
    position: fixed;
    top: -50px;
    left: 50%;
    width: 90%;
    transform: translateX(-50%);
    border-radius: 20px;
    overflow: hidden;
    border: solid 1px $primaryColor;
    transition: 0.3s;
    box-sizing: border-box;
    z-index: 100;

    @media screen and (min-width: #{$media-900}) {
      width: calc(80vw - 300px);
      right: 0;
      left: auto;
      transform: translateX(-10vw);
    }

    &--visible {
      top: 16px;
    }

    &__icon {
      all: unset;
      position: absolute;
      top: 0px;
      left: 2px;
      cursor: pointer;
      color: #aaa;
      font-size: 12px;
      padding: 12px;
      box-sizing: border-box;

      &--menu {
        @media screen and (min-width: #{$media-900}) {
          display: none;
        }
      }

      &--right {
        left: auto;
        right: 2px;
      }

      &--notifications::before {
        content: '';
        position: absolute;
        top: 10px;
        right: 10px;
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background-color: firebrick;
      }
    }

    &__input {
      border: 0;
      width: 100%;
      height: 100%;
      padding: 10px 38px;
      text-align: center;
      box-sizing: border-box;
      font-weight: $normal;
      font-size: 16px;
      outline: none;
    }

    &__img {
      position: absolute;
      top: 9px;
      right: 9px;
      width: 20px;
      height: 20px;
      object-fit: cover;
      border-radius: 50%;
    }
  }
</style>

